// DensityToggle — Three-button selector for workspace display density.
// Tactical (T): maximum info, monospace stats. Analytical (A): expanded charts.
// Monitoring (M): minimal — signals and top picks only.

import clsx from 'clsx';
import { useOSStore, type WorkspaceDensity } from '../store/useOSStore';

const MODES: { id: WorkspaceDensity; label: string; title: string }[] = [
  { id: 'tactical',   label: 'T', title: 'Tactical — maximum information density' },
  { id: 'analytical', label: 'A', title: 'Analytical — charts expanded'           },
  { id: 'monitoring', label: 'M', title: 'Monitoring — minimal, signals only'     },
];

export function DensityToggle() {
  const { density, setDensity } = useOSStore();

  return (
    <div
      className="hidden md:flex items-center gap-px bg-surface-2 rounded-md p-px border border-surface-4"
      title="Display density"
    >
      {MODES.map(({ id, label, title }) => (
        <button
          key={id}
          title={title}
          onClick={() => setDensity(id)}
          className={clsx(
            'w-5 h-5 rounded text-[9px] font-bold uppercase tracking-wider transition-all duration-150',
            density === id
              ? 'bg-brand text-white'
              : 'text-gray-600 hover:text-gray-400',
          )}
        >
          {label}
        </button>
      ))}
    </div>
  );
}
